import { IItem } from '@bimser/core';
import { GetIconComponent } from '@bimser/icons';
import classNames from 'classnames/bind';
import * as React from 'react';
import BCBadge from '../../BCBadge';
import Styles from '../assets/style.scss';
const cx = classNames.bind(Styles);

const badgeStyle: React.CSSProperties = {
	marginLeft: '5px'
};

const bcIconStyles: React.CSSProperties = {
	verticalAlign: 'inherit',
	lineHeight: '100%'
};

const MenuItemInline = (props: { item: IItem; textCustomStyle?: React.CSSProperties }) => {
	const getMenuNameWord = (text: string) =>
		text
			.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, '')
			.replace(/ {2}/g, ' ')
			.trim()
			.split(' ')
			.slice(0, 2)
			.map(each => each.charAt(0).toUpperCase())
			.join('');

	const renderIcon = () => {
		if (props.item.icon) {
			return GetIconComponent(props.item.icon, { style: bcIconStyles });
		} else {
			return (
				<div
					className="bcIcon"
					style={bcIconStyles}
				>
					<div className="nameWord">{getMenuNameWord(props.item.text)}</div>
				</div>
			);
		}
	};

	const renderText = () => (
		<span
			title={props.item.text}
			className="ant-menu-text-custom"
			style={props.textCustomStyle}
		>
			{props.item.text}
		</span>
	);

	const renderBadge = () => (
		<BCBadge
			{...props.item.badge}
			style={badgeStyle}
		/>
	);

	const classNames = cx({
		height100: true
	});

	return (
		<div
			className={[classNames, props.item.className].join(' ')}
			style={props.item.style}
		>
			{renderIcon()}
			{renderText()}
			{renderBadge()}
		</div>
	);
};
export default MenuItemInline;
